module.exports = __webpack_public_path__ + "img/glasdach.8759962b.jpg";